import React, { Component } from 'react';
import { Button, Select, InputNumber, Modal, Radio, Upload, message, Icon, Tooltip, Table, Cascader } from 'antd';
import API_URL from "../../../common/url";
import $, { xToken } from '../../../common/AjaxRequest';
import '../css/style.less';
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new'
const RadioGroup = Radio.Group;
const { Option } = Select;

class ModifyReferencePriceModal extends Component {
    state = {
        visible: false,
        evaluateRecordId: '',
        areaList: [], // 治疗领域
        investigationAreaId: undefined, // 项目领域ID
        diseaseClassList: [], // 疾病分类列表
        diseaseClassId: undefined, // 疾病分类ID
        diseaseClassName: undefined, // 疾病分类名称
        diseaseList: [], // 疾病列表
        diseaseId: undefined, // 疾病ID
        diseaseName: undefined, // 疾病名称
        productTypeParentId: undefined, // 项目领域
        researchProductTypeId: undefined, // 项目分类ID
        standardVisitUnitPrice: '', // FTE单价
        inGroupPhaseUnitPrice: '', // 入组阶段(FPI-LPI)单价(元/中心)
        treatmentPeriodUnitPrice: '', // 治疗期单价(元/中心)
        researchProductTypeList: [], // 研究产品类型列表
    }
    // 打开修改参考价格弹窗
    show = (record) => {
        const {
            evaluateRecordId,
            calResearchProductTypeId,
            calResearchProductTypeParentId,
            calInvAreaId,
            calDiseaseClassId,
            calDiseaseId,
            calInvAreaName,
            calDiseaseName,
            calDiseaseClassName,
            inGroupPhaseUnitPrice,
            treatmentPeriodUnitPrice,
        } = record || {};

        // 处理研究产品类型级联值
        let cascaderValue;
        if (calResearchProductTypeParentId > 0) {
            cascaderValue = [calResearchProductTypeParentId, calResearchProductTypeId];
        } else {
            cascaderValue = calResearchProductTypeId ? [calResearchProductTypeId] : undefined;
        }

        this.setState({
            evaluateRecordId,
            investigationAreaId: calInvAreaId != null ? String(calInvAreaId) : undefined,
            diseaseClassId: calDiseaseClassId,
            diseaseClassName: calDiseaseClassName,
            diseaseId: calDiseaseId,
            diseaseName: calDiseaseName,
            researchProductTypeId: cascaderValue,
            inGroupPhaseUnitPrice: inGroupPhaseUnitPrice || '',
            treatmentPeriodUnitPrice: treatmentPeriodUnitPrice || '',
            visible: true,
        }, async () => {
            await this.queryConfigWithChildByType();
            await this.loadAreaList();
            if (calResearchProductTypeId) {
                this.loadStandardVisitAmount({
                    researchProductTypeId: calResearchProductTypeId,
                    investigationAreaId: calInvAreaId || '',
                    diseaseClassId: calDiseaseClassId || '',
                    diseaseId: calDiseaseId || '',
                    evaluateRecordId: evaluateRecordId,
                });
            }
        });
    }
    //研究产品类型选项
    queryConfigWithChildByType = () => {
        return new Promise((resolve, reject) => {
            const options = {
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => {
                    const { list = [] } = res;
                    const newList = list.map(el => ({
                        value: el.evaluateConfigureId,
                        code: el.code,
                        label: el.configureValue,
                        children: el.childList.length ? el.childList.map(childData => ({
                            value: childData.evaluateConfigureId,
                            label: childData.configureValue,
                        })) : undefined,
                    }));
                    this.setState({
                        researchProductTypeList: newList || []
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            }
            $.sendRequest(options);
        })
    }
    //获取项目领域、项目分类选项
    loadAreaList = () => {
        return new Promise((resolve, reject) => {
            const options = {
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => {
                    this.setState({
                        areaList: res.areaList || []
                    }, () => resolve(res));
                },
                failResult: (err) => {
                    reject(err);
                },
            }
            $.sendRequest(options);
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            evaluateRecordId: '',
            areaList: [], // 治疗领域
            investigationAreaId: undefined, // 项目领域ID
            diseaseClassList: [], // 疾病分类列表
            diseaseClassId: undefined, // 疾病分类ID
            diseaseClassName: undefined, // 疾病分类名称
            diseaseList: [], // 疾病列表
            diseaseId: undefined, // 疾病ID
            diseaseName: undefined, // 疾病名称
            researchProductTypeId: undefined, // 研究产品类型
            standardVisitUnitPrice: '', // FTE单价
            inGroupPhaseUnitPrice: '', // 入组阶段(FPI-LPI)单价(元/中心)
            treatmentPeriodUnitPrice: '', // 治疗期单价(元/中心)
        });
    }
    //获取参考标准访视单价
    loadStandardVisitAmount = (data) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.standardVisitAmount,
            data,
            dataType: 'json',
            doneResult: res => {
                let standardVisitUnitPrice = res.evaluateStandardVisitUnitPrice && res.evaluateStandardVisitUnitPrice.originalUnitPrice || 0;
                this.setState({
                    standardVisitUnitPrice,
                })
            }
        }
        $.sendRequest(options)
    }
    handleChange = (value, key) => {
        const { evaluateRecordId, investigationAreaId, diseaseClassId, diseaseId, researchProductTypeId } = this.state;
        // 安全获取研究产品类型ID（Cascader 数组取最后一个元素）
        const getResearchProductTypeId = (cascaderValue) => {
            return Array.isArray(cascaderValue) && cascaderValue.length > 0
                ? cascaderValue[cascaderValue.length - 1]
                : undefined;
        };
        switch (key) {
            case 'researchProductTypeId':
                // 研究产品类型ID
                this.setState({
                    researchProductTypeId: value,
                }, () => {
                    this.loadStandardVisitAmount({
                        researchProductTypeId: getResearchProductTypeId(value),
                        investigationAreaId: investigationAreaId || '',
                        diseaseClassId: diseaseClassId || '',
                        diseaseId: diseaseId || '',
                        evaluateRecordId: evaluateRecordId,
                    });
                })
                break;
            case 'investigationAreaId':
                this.setState({
                    investigationAreaId: value,
                    diseaseClassId: undefined,
                    diseaseClassName: undefined,
                    diseaseId: undefined,
                    diseaseName: undefined,
                });
                this.loadStandardVisitAmount({
                    researchProductTypeId: getResearchProductTypeId(researchProductTypeId),
                    investigationAreaId: value,
                    evaluateRecordId: evaluateRecordId,
                });
                break
            case 'diseaseClassId':
                // 疾病分类ID
                if(JSON.stringify(value) === '{}') {
                    this.setState({
                        diseaseClassId: undefined,
                        diseaseClassName: undefined,
                        diseaseId: undefined,
                        diseaseName: undefined,
                    });
                    this.loadStandardVisitAmount({
                        researchProductTypeId: getResearchProductTypeId(researchProductTypeId),
                        investigationAreaId: investigationAreaId,
                        // diseaseClassId: undefined,
                        evaluateRecordId: evaluateRecordId,
                    });
                }else{
                    const { value: id, text } = value;
                    this.setState({
                        diseaseClassId: id,
                        diseaseClassName: text,
                        diseaseId: undefined,
                        diseaseName: undefined,
                    });
                    this.loadStandardVisitAmount({
                        researchProductTypeId: getResearchProductTypeId(researchProductTypeId),
                        investigationAreaId: investigationAreaId,
                        diseaseClassId: id,
                        evaluateRecordId: evaluateRecordId,
                    });
                }
                break;
            case 'diseaseId':
                // 疾病ID
                if(JSON.stringify(value) === '{}') {
                    this.setState({
                        diseaseId: undefined,
                        diseaseName: undefined,
                    });
                    this.loadStandardVisitAmount({
                        researchProductTypeId: getResearchProductTypeId(researchProductTypeId),
                        investigationAreaId: investigationAreaId,
                        diseaseClassId: diseaseClassId,
                        // diseaseId: '0',
                        evaluateRecordId: evaluateRecordId,
                    });
                }else{
                    const { value: id, text } = value;
                    this.setState({
                        diseaseId: id,
                        diseaseName: text,
                    });
                    this.loadStandardVisitAmount({
                        researchProductTypeId: getResearchProductTypeId(researchProductTypeId),
                        investigationAreaId: investigationAreaId,
                        diseaseClassId: diseaseClassId,
                        diseaseId: id,
                        evaluateRecordId: evaluateRecordId,
                    });
                }
                break;
            default:
                this.setState({ [key]: value })
                break;
        }
    }

    // 提交修改参考价格
    sumbit = () => {
        const {
            evaluateRecordId, investigationAreaId, diseaseClassId, diseaseId, standardVisitUnitPrice, researchProductTypeId,
            inGroupPhaseUnitPrice, treatmentPeriodUnitPrice,
        } = this.state;
        // if (!investigationAreaId) return message.warning('请选择项目领域');

        const getResearchProductTypeId = (cascaderValue) => {
            return Array.isArray(cascaderValue) && cascaderValue.length > 0
                ? cascaderValue[cascaderValue.length - 1]
                : undefined;
        };

        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.modifyReferencePrice,
            data: {
                evaluateRecordId,
                investigationAreaId,
                diseaseClassId,
                diseaseId,
                standardVisitUnitPrice,
                researchProductTypeId: getResearchProductTypeId(researchProductTypeId),
                inGroupPhaseUnitPrice,
                treatmentPeriodUnitPrice,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false });

                this.props.loadData();
                this.hide();
            }
        });
    }

    render() {
        const {
            visible, loading, areaList,
            investigationAreaId, diseaseClassId, diseaseClassName, diseaseId, diseaseName, standardVisitUnitPrice,
            inGroupPhaseUnitPrice, treatmentPeriodUnitPrice,
            researchProductTypeId, researchProductTypeList,
        } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        let areaOption = areaList.map(el => ({ label: el.investigationAreaName, value: el.investigationAreaId }))
        //areaOption.push({ label: '-', value: 0 }); //治疗领域
        return (
            <Modal
                title="修改参考单价"
                visible={visible}
                onOk={this.sumbit}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width={800}
                bodyStyle={{ maxHeight: 600 }}
            >
                <div style={{ padding: '15px 30px' }}>
                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%' }}>
                        <label style={{ padding: '10px', width: 150, textAlign: 'right' }}>{asterisk}参考标准访视单价</label>
                        <span className="">
                            <Cascader 
                                options={researchProductTypeList} 
                                placeholder="请选择研究产品类型"
                                style={{ width: 140 }}
                                allowClear={false}
                                value={researchProductTypeId}
                                onChange={value => this.handleChange(value, 'researchProductTypeId')}
                            />
                            <Select 
                                value={investigationAreaId}
                                style={{ width: 120 }}
                                showSearch={true}
                                allowClear={true}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                placeholder='请选择项目领域'
                                onChange={value => this.handleChange(value, 'investigationAreaId')}
                            >
                                {areaOption.map(el => (
                                    <Option disabled={el.disabled} key={el.value} value={String(el.value)}>{el.label}</Option>
                                ))}
                            </Select>
                            <SearchRetrieve
                                value={diseaseClassName}
                                name="diseaseClassId"
                                showName="diseaseClassName"
                                style={{ width: 120 }}
                                keyword="diseaseClassName"
                                placeholder="请选择疾病分类"
                                disabled={!investigationAreaId || investigationAreaId==='0'}
                                params={{limit: 20, investigationAreaId: investigationAreaId ? investigationAreaId : undefined}}
                                url={API_URL.common.queryDiseaseClassByAreaId}
                                config={{ id: 'diseaseClassId', name: 'diseaseClassName'}}
                                // extraOption={[{ label: '-', value: 0 }]}
                                onChange={value => this.handleChange(value, 'diseaseClassId')}
                            />
                            <SearchRetrieve
                                value={diseaseName}
                                name="diseaseId"
                                showName="diseaseName"
                                style={{ width: 120 }}
                                keyword="keyword"
                                placeholder="请选择疾病"
                                disabled={!diseaseClassId || diseaseClassId==='0' || !investigationAreaId || investigationAreaId==='0'}
                                params={{limit: 20, investigationAreaId: investigationAreaId ? investigationAreaId : undefined, diseaseClassId: diseaseClassId ? diseaseClassId : undefined}}
                                url={API_URL.common.queryAllDisease}
                                config={{ id: 'diseaseId', name: 'diseaseName'}}
                                // extraOption={[{ label: '-', value: 0 }]}
                                onChange={value => this.handleChange(value, 'diseaseId')}
                            />
                        </span>
                    </div>
                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%' }}>
                        <label style={{ padding: '10px', width: 100, textAlign: 'right' }}>标准访视单价</label>
                        <span className="">
                            {standardVisitUnitPrice}
                        </span>
                    </div>
                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%' }}>
                        <label style={{ padding: '10px', width: 200, textAlign: 'right' }}>入组阶段(FPI-LPI)单价(元/中心)</label>
                        <span className="">
                            <InputNumber
                                style={{ width: 160 }}
                                value={inGroupPhaseUnitPrice}
                                onChange={value => this.setState({ inGroupPhaseUnitPrice: value })}
                                min={0}
                                precision={2}
                                placeholder="请输入入组阶段单价"
                            />
                        </span>
                    </div>
                    <div className="item" style={{display: 'flex', alignItems: 'center', width: '100%' }}>
                        <label style={{ padding: '10px', width: 200, textAlign: 'right' }}>治疗期单价(元/中心)</label>
                        <span className="">
                            <InputNumber
                                style={{ width: 160 }}
                                value={treatmentPeriodUnitPrice}
                                onChange={value => this.setState({ treatmentPeriodUnitPrice: value })}
                                min={0}
                                precision={2}
                                placeholder="请输入治疗期单价"
                            />
                        </span>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ModifyReferencePriceModal;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/ModifyReferencePriceModal.js